// frontend/src/components/pages/chat/ErrorModal.jsx
import React from "react";

const ErrorModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white dark:bg-bg-40 rounded-2xl shadow-lg p-8 max-w-sm w-full flex flex-col items-center">
        <div className="mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"
            />
          </svg>
        </div>
        <div className="text-lg font-semibold text-center text-fg-50 mb-2">
          Oops! Something went wrong
        </div>
        <div className="text-center text-fg-60 mb-6">
          {message}
        </div>
        <button
          onClick={onClose}
          className="px-6 py-2 rounded-lg bg-bg-50/10 hover:bg-bg-50/20 text-fg-50 font-medium transition-colors"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ErrorModal; 